export default __webpack_public_path__ + "static/lookback-a42652c5675a5225e3f03193bdc88e11.png";